export enum ConversationDataEventObject {
  CONVERSATION_PREVIEW = 'conversation_preview',
}
